import styled from 'styled-components';

interface ITextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  value?: string;
}

export const TextArea = styled.textarea<ITextAreaProps>`
  width: 100%;
  height: 80px;
  padding: 10px;
  font: 14px EffraRegular;
  border: 1px solid darkgrey;
  border-radius: 4px;
`;
